import { useEffect } from 'react';

import type { OpenCoreInvitesFunction } from './CoreInvitesContext.tsx';
import { CoreInvitesSource } from './constants.ts';

const INVITE_DIALOG_PARAM = 'inviteDialog';

const getOpenModalParam = () => {
	return new URLSearchParams(window.location.search.substring(1)).get(INVITE_DIALOG_PARAM) || '';
};

export function useAutoOpenInviteFromParam(openCoreInvites: OpenCoreInvitesFunction): void {
	useEffect(() => {
		if (!window) {
			return;
		}

		if (getOpenModalParam() !== 'open') {
			return;
		}

		openCoreInvites(CoreInvitesSource.OPEN_MODAL_QUERY_PARAM);

		// remove the query param from the URL without reloading the page
		const url = new URL(window.location.href);
		url.searchParams.delete(INVITE_DIALOG_PARAM);
		window.history.replaceState({}, document.title, url.toString());
	}, [openCoreInvites]);
}
